import React from "react";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

function AppVersionStatusCellTemplate({ data }) {
    const { t } = useTranslation();

    return data.isEnabled ? (
        <span className="c-tag c-tag--sml c-tag--active--outline">{t("ADMINISTRATION.APP_RELEASE.STATUS.ENABLED")}</span>
    ) : (
        <span className="c-tag c-tag--sml c-tag--inactive--outline">
            {t("ADMINISTRATION.APP_RELEASE.STATUS.DISABLED")}
        </span>
    );
}

AppVersionStatusCellTemplate.propTypes = {
    data: PropTypes.object.isRequired,
};

export default AppVersionStatusCellTemplate;
